export enum ActionType {
  Link,
  Patch,
  Delete,
  OpenCreateEditModal
}
